import { PotentialLocation } from '@/models/gen/graphql';

export const ROUTE_SEP = '||';
export const LOCATION_SEP = '::';

export const formatLocationKey = (name: string, airportCode: string): string => `${name}${LOCATION_SEP}${airportCode}`;
export const parseLocationSubKey = (subKey: string): { name: string; airportCode: string; subKey: string } => {
  const parts = subKey.split(LOCATION_SEP);
  const name = parts[0] || '';
  const airport = parts[1] || '';
  return { name, airportCode: airport, subKey };
};

export const formatRoutekey = (puLocationName: string, puAirport: string, doLocationName?: string, doAirport?: string): string =>
  `${formatLocationKey(puLocationName, puAirport)}${ROUTE_SEP}${formatLocationKey(doLocationName || '', doAirport || '')}`;

export const parseRouteKey = (
  routeKey: string
): [{ name: string; airportCode: string; subKey: string }, { name: string; airportCode: string; subKey: string }] => {
  const [puSub, doSub] = routeKey.split(ROUTE_SEP);
  return [parseLocationSubKey(puSub), parseLocationSubKey(doSub)];
};

export const formatFullAddress = (location: PotentialLocation): string => {
  if (!location?.address) return '';
  const parts = [location.address, location.cityName, location.stateCode, location.zipCode, location.countryCode].filter(Boolean);
  return parts.join(', ');
};
